<mat-card appearance="outlined">
  <mat-card-title>
    <div  flex layout="row" layout-align="space-between center">
      <span class="edit-screen-card-title"
      [translate]="'clients.address'">ID card data</span>
    </div>
  </mat-card-title>
  <mat-card-content class="remove-mat-form-field-wrapper">
    <form [formGroup]="profileDataForm"
          [itfgPermissions]="['USER_WRITE']">
    <div layout="column">
      <div flex
        layout="row"
        layout-align="space-between stretch"
        class="column-gap-10"
        *ngxPermissionsOnly="['USER_ID_DATA_READ']">
        <mat-form-field flex="40">
          <input matInput
            itfgTrimInput
            type="text"
            formControlName="idCardNumber"
            #idCardNumber
            placeholder="{{ 'global.number' | translate }}" />
            <mat-label>{{ 'global.number' | translate }}</mat-label>
            @if (profileDataForm.controls['idCardNumber'].errors) {
              <mat-error
                [translate]="'forms.invalidFormat'">Invalid
                format
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="edit-blacklist-aditional-padding"
            [ngStyle]="{'flex': (idCardNumber.value) ? '40' : '50'}">
            <input matInput
              formControlName="idCardIssuedDate"
              [matDatepicker]="picker"
              placeholder="{{ dateIssuedLabel}}">
              <mat-label>{{ dateIssuedLabel}}</mat-label>
              <mat-datepicker-toggle matSuffix
              [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker [touchUi]="false"
              #picker></mat-datepicker>
            </mat-form-field>
</div>
<mat-form-field flex
  *ngxPermissionsOnly="['USER_ID_DATA_READ']">
  <mat-select matInput
    placeholder="{{'clients.issuedBy' | translate}}"
    formControlName="idCardIssuerID">
    @for (policeDep of policeDepartments; track policeDep) {
      <mat-option [disabled]="(['USER_WRITE'] | isUnauthorized | async)"
        [value]="policeDep.id">
        {{ policeDep.name }}
      </mat-option>
    }
  </mat-select>
  <mat-label>{{'clients.issuedBy' | translate}}</mat-label>
</mat-form-field>
<mat-form-field flex>
  <input matInput
    type="text"
    formControlName="idCardCity"
    [matAutocomplete]="idCity"
    itfgSelectFirstAutocompleteOptionOnBlur
    placeholder="{{ 'clients.residentCityByIdCard' | translate }}" />
    <mat-label>{{ 'clients.residentCityByIdCard' | translate }}</mat-label>
    @if (profileDataForm.get('idCardCity')?.hasError('lacksLatin')) {
      <mat-error
      [translate]="'forms.fieldShouldNotHaveLatinCharacters'"></mat-error>
    }
    @if (profileDataForm.get('idCardCity')?.hasError('notValidCity') && !(profileDataForm.get('idCardCity')?.hasError('lacksLatin'))) {
      <mat-error
      [translate]="'forms.notValidCity'"></mat-error>
    }
    <mat-autocomplete #idCity="matAutocomplete"
      itfgHighlightFirstAutocompleteOptionOnChange
      [displayWith]="mapCityToDisplayValue">
      @for (city of idCityList; track city) {
        <mat-option
          [value]="city">
          {{ city | cityDisplayText }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field flex>
    <input matInput
      itfgTrimInput
      type="text"
      formControlName="idCardAddressName"
      placeholder="{{ 'clients.addressByIdCard' | translate }}" />
      <mat-label>{{ 'clients.addressByIdCard' | translate }}</mat-label>
      @if (profileDataForm.hasError('cityRequiredForAddress')) {
        <mat-hint [ngStyle]="{color: 'red' }"
          [translate]="'forms.addressRequiresCity'">Address requires city
        </mat-hint>
      }
      @if (profileDataForm.get('idCardAddressName')?.value) {
        <button matSuffix
          matTooltip="{{ 'global.openWithGoogleMaps' | translate }}"
          matTooltipPosition="above"
          mat-icon-button
          tabindex="-1"
          (click)="openLocationMapForIdCardAddress()">
          <mat-icon>place</mat-icon>
        </button>
      }
    </mat-form-field>
    <mat-form-field>
      <input matInput
        type="text"
        formControlName="currentCity"
        [matAutocomplete]="currentCity"
        itfgSelectFirstAutocompleteOptionOnBlur
        placeholder="{{ 'clients.currentResidentCity' | translate }}" />
        <mat-label>{{ 'clients.currentResidentCity' | translate }}</mat-label>
        @if (profileDataForm.get('currentCity')?.hasError('lacksLatin')) {
          <mat-error
          [translate]="'forms.fieldShouldNotHaveLatinCharacters'"></mat-error>
        }
        @if (profileDataForm.get('currentCity')?.hasError('notValidCity') && !(profileDataForm.get('currentCity')?.hasError('lacksLatin'))) {
          <mat-error
          [translate]="'forms.notValidCity'"></mat-error>
        }
        <mat-autocomplete #currentCity="matAutocomplete"
          itfgHighlightFirstAutocompleteOptionOnChange
          [displayWith]="mapCityToDisplayValue">
          @for (city of currentCityList; track city) {
            <mat-option
              [value]="city">
              {{ city | cityDisplayText }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field>
        <input matInput
          itfgTrimInput
          type="text"
          formControlName="currentAddressName"
          placeholder="{{ 'clients.currentAddress' | translate }}" />
          <mat-label>{{ 'clients.currentAddress' | translate }}</mat-label>
          @if (profileDataForm.hasError('currentCityRequiredForAddress')) {
            <mat-hint [ngStyle]="{color: 'red' }"
              [translate]="'forms.addressRequiresCity'">Address requires city
            </mat-hint>
          }
          @if (profileDataForm.get('currentAddressName')?.value) {
            <button matSuffix
              matTooltip="{{ 'global.openWithGoogleMaps' | translate }}"
              matTooltipPosition="above"
              mat-icon-button
              tabindex="-1"
              (click)="openLocationMapForCurrentAddress()">
              <mat-icon>place</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>
